// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1Ydy0","content":"Consent_content__2ajbU","footer":"Consent_footer__3XJxt"};